import { PreviewDetailsSection, PreviewFormField, UserRoles } from '../interfaces';

/**
 * Ready to submit list of notes constant
 */
export const SUBMIT_NOTES: { heading: string; notes: string[] } = {
    heading:
        'Please confirm that all the information is accurate and up-to-date. If you need to make changes click the "Edit" Button in each section to update teh information',
    notes: [
        'You can update the account details anytime after creation',
        'The accound will be activated immediately upon submission',
        'You will receive email confirmation and accound details',
    ],
};

/**
 * Form field constants. Default - used by other user roles that requires the same data structure
 */
export const PREVIEW_FORM_FIELDS: PreviewFormField[] = [
    {
        label: 'First Name',
        placeholder: 'Placeholder',
        fieldName: 'firstName',
    },
    {
        label: 'First Name',
        placeholder: 'Placeholder',
        fieldName: 'lastName',
    },
    {
        label: 'Email Address',
        placeholder: 'Placeholder',
        fieldName: 'emailAddress',
    },
    {
        label: 'Contact Number',
        placeholder: 'Placeholder',
        fieldName: 'contactNumber',
    },
    {
        label: 'Password',
        placeholder: 'Placeholder',
        fullWidth: true,
        fieldName: 'password',
    },
];

/** Dealer preview fields — order matches the dealer input-information form layout. */
export const DEALER_PREVIEW_FIELDS: PreviewFormField[] = [
    {
        label: 'First Name',
        placeholder: 'Placeholder',
        fieldName: 'firstName',
    },
    {
        label: 'Last Name',
        placeholder: 'Placeholder',
        fieldName: 'lastName',
    },
    {
        label: 'Dealer ID',
        placeholder: 'Placeholder',
        fieldName: 'dealerId',
    },
    {
        label: 'Dealer Alias',
        placeholder: 'Placeholder',
        fieldName: 'dealerAlias',
    },
    {
        label: 'Business Name',
        placeholder: 'Placeholder',
        fieldName: 'businessName',
    },
    {
        label: 'Contact Person',
        placeholder: 'Placeholder',
        fieldName: 'contactPerson',
    },
    {
        label: 'Contact Number',
        placeholder: 'Placeholder',
        fieldName: 'contactPersonPhone',
    },
    {
        label: 'Email Address',
        placeholder: 'Placeholder',
        fieldName: 'emailAddress',
    },
    {
        label: 'City',
        placeholder: 'Placeholder',
        fieldName: 'city',
    },
    {
        label: 'State',
        placeholder: 'Placeholder',
        fieldName: 'state',
    },
    {
        label: 'Region',
        placeholder: 'Placeholder',
        fieldName: 'region',
    },
    {
        label: 'Password',
        placeholder: 'Placeholder',
        fullWidth: true,
        fieldName: 'password',
    },
];

/**
 * Layout constant for the preview details page based on selected user role
 */
export const PREVIEW_DETAILS_LAYOUT: Partial<
    Record<Exclude<UserRoles, 'none'>, PreviewDetailsSection>
> = {
    subDealer: {
        fields: PREVIEW_FORM_FIELDS,
        extra: [
            {
                label: 'Dealer(s) associated with this account',
                placeholder: 'Selected Dealers',
                extraClasses: 'flex items-center gap-2 flex-wrap',
                fieldName: 'selectedDealers',
            },
        ],
    },
    dealer: {
        fields: DEALER_PREVIEW_FIELDS,
    },
    guest: {
        fields: PREVIEW_FORM_FIELDS,
    },
    advertiser: {
        fields: PREVIEW_FORM_FIELDS,
    },
    dealerAdmin: {
        fields: PREVIEW_FORM_FIELDS,
    },
    techOfficer: {
        fields: PREVIEW_FORM_FIELDS,
    },
    superAdmin: {
        fields: PREVIEW_FORM_FIELDS,
    },
};
